import axios from "axios";

const API_BASE = `${process.env.REACT_APP_COLLEGE_ERP_API}api/`;

// ✅ Centralized error handler
const errorHandler = (error, navigate) => {
  console.error("Error fetching data", error?.response);

  const errData = error?.response?.data;

  if (
    errData?.err?.name === "JsonWebTokenError" ||
    errData?.message === "Unauthorized"
  ) {
    localStorage.removeItem("token");
    navigate("/");
  } else {
    alert(`Failed to fetch ${errData.error || "data"}`);
  }
};

// ✅ Reusable fetch function
export const fetchInvoices = async ({ branch, studentId, token, navigate }) => {
  try {
    const response = await axios.get(`${API_BASE}Invoice`, {
      params: { branch, studentId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    errorHandler(error, navigate);
    return {
      data: [],
      totalPages: 1,
      error: error?.response?.data || error.message,
    };
  }
};

// Reusable API fetch function
export const fetchStudentFeeStructure = async ({
  branch,
  studentId,
  token,
  navigate,
}) => {
  try {
    const response = await axios.get(`${API_BASE}student-fee`, {
      params: { branch, studentId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 && response.data) {
      const data = response.data;

      const allowedKeys = ["1stYear", "2ndYear", "3rdYear", "4thYear"];

      // Extract specific keys from the root level of `data`
      const extractedFees = Object.entries(data)
        .filter(
          ([key, value]) =>
            allowedKeys.includes(key) &&
            value !== undefined &&
            value !== null &&
            value !== ""
        )
        .map(([description, amount]) => ({
          description: description.trim(),
          amount: Number(amount),
        }));

      // Normalize existing fees array (if any)
      const existingFees = Array.isArray(data.fees)
        ? data.fees.filter(
            (fee) =>
              fee &&
              typeof fee === "object" &&
              fee.description &&
              fee.amount !== undefined &&
              fee.amount !== null &&
              fee.amount !== ""
          )
        : [];

      // Combine both
      const fees = [...existingFees, ...extractedFees];
      console.log("Fees:", fees);
      // Optional: remove duplicates based on `description`
      const uniqueFees = [];
      const seen = new Set();
      for (const fee of fees) {
        if (!seen.has(fee.description)) {
          seen.add(fee.description);
          uniqueFees.push(fee);
        }
      }

      // Return final
      return {
        data,
        fees: uniqueFees,
        error: null,
      };
    } else {
      return {
        data: null,
        fees: [],
        error: "No data found or unexpected status code",
      };
    }
  } catch (error) {
    errorHandler(error, navigate);
    return {
      data: null,
      fees: [],
      error: error?.response?.data || error.message,
    };
  }
};
